import { Identifiable, Unavailability } from "@planzone/dto";
import { Filter } from "@planzone/dto";

import { isFilteredByResources } from "./resources";

function isUnavailabilityFiltered(
  unavailability: Identifiable<Unavailability>,
  filter: Filter,
): boolean {
  return isFilteredByResources(unavailability, filter);
}

export { isUnavailabilityFiltered };
